"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typography = void 0;
var typography = exports.typography = {
  h1: {
    fontSize: '96px',
    lineHeight: 112 / 96,
    // 112px / 96px ?
    letterSpacing: '-1.5px',
    fontWeight: 300
  },
  h2: {
    fontSize: '60px',
    lineHeight: 72 / 60,
    // 72px / 60px ?
    letterSpacing: '-0.5px',
    fontWeight: 300
  },
  h3: {
    fontSize: '48px',
    lineHeight: 56 / 48,
    // 56px / 48px ?
    letterSpacing: '0',
    fontWeight: 400
  },
  h4: {
    fontSize: '34px',
    lineHeight: 42 / 34,
    // 42px / 34px ?
    letterSpacing: '0.25px',
    fontWeight: 400
  },
  h5: {
    fontSize: '24px',
    lineHeight: 32 / 24,
    // 32px / 24px ?
    letterSpacing: '0',
    fontWeight: 500
  },
  h6: {
    fontSize: '20px',
    lineHeight: 32 / 20,
    // 32px / 20px ?
    letterSpacing: '0.15px',
    fontWeight: 500
  },
  subtitle1: {
    fontSize: '16px',
    lineHeight: 28 / 16,
    // 28px / 16px ?
    letterSpacing: '0.15px',
    fontWeight: 500
  },
  subtitle2: {
    fontSize: '14px',
    lineHeight: 22 / 14,
    // 22px / 14px ?
    letterSpacing: '0.15px',
    fontWeight: 500
  },
  body1: {
    fontSize: '14px',
    lineHeight: 22 / 14,
    // 22px / 14px ?
    letterSpacing: '0.15px',
    fontWeight: 400
  },
  body2: {
    fontSize: '13px',
    lineHeight: 20 / 13,
    // 20px / 13px ?
    letterSpacing: '0.15px',
    fontWeight: 400
  },
  caption: {
    fontSize: '12px',
    lineHeight: 16 / 12,
    // 16px / 12px ?
    letterSpacing: '0.4px',
    fontWeight: 400
  },
  button: {
    fontSize: '14px',
    lineHeight: 24.5 / 14,
    // 24.5px / 14 px ?
    letterSpacing: '0.4px',
    fontWeight: 500,
    textTransform: 'uppercase'
  },
  overline: {
    fontSize: '10px',
    lineHeight: 16 / 10,
    // 16px / 10px ?
    letterSpacing: '0.25px',
    fontWeight: 400,
    textTransform: 'uppercase'
  }
};